// React Error Boundary with feedback via Message/Notification contexts
import React from 'react';
import ErrorFeedback from '@app/ErrorFeedback';

export default class Boundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, info) {
        console.error('Error caught by boundary:', error, info);
        if (this.props.onError) {
            this.props.onError(error, info);
        }
    }

    handleReload = () => {
        window.location.reload();
    };

    render() {
        if (!this.state.hasError) {
            return this.props.children;
        }

        return <ErrorFeedback error={this.state.error} onReload={this.handleReload} />;
    }
}
